// extracted by mini-css-extract-plugin
export var section = "benefits-module--section--3Foz_";
export var content = "benefits-module--content--24e10";